<template>
  <div class="loginPage">
    <header class="login__nav">
      <div class="navContainer">
        <router-link to="/">
          <img src="@/assets/images/header_logo.png" alt="Logo" />
        </router-link>
      </div>
    </header>
    <div class="login__content">
      <div class="login__wrapper" v-if="email_show">
        <div class="login__fields">
          <h2 class="login__fields__header primaryHeader mb-4">Forgot Password?</h2>
          <p class="txt--xs login__label">Enter your registered email to get a password reset link.</p>
          <div class="form-group">
            <label for="email" class="login__label">Email</label>
            <input
              type="email"
              id="email"
              class="login__input"
              placeholder="Enter your email"
              autocomplete="off"
              v-model="email"
            />
          </div>
          <div class="login__forget">
            <p class="txt--xs text-danger text-left">{{errorResponse}}</p>
            <p class="txt--xs text-success text-left">{{successResponse}}</p>
          </div>
        </div>
        <div class="login__submit mt-4">
          <button
            type="button"
            @click="sendEmail"
            class="button button--md button--primary login__button"
            :class="{'disabled':email == ''}"
          >Send Link</button>
          <p class="txt--xs">
            Don’t have an account yet?
            <a href="mailto:hello@piedparker.com?subject=Hello!" class="txt--primary txt--semi-bold">Get in touch</a>
          </p>
        </div>
      </div>
      <div class="login__wrapper" v-if="password_show">
        <div class="login__fields">
          <h2 class="login__fields__header primaryHeader mb-4">Reset password</h2>
            <div class="form-group">
                <label for="password" class="login__label">Password</label>
                <input
                type="password"
                id="password"
                class="login__input"
                placeholder="Enter new Password"
                autocomplete="off"
                v-model="password"
                />
            </div>
            <div class="form-group mb-2">
              <label for="conf_password" class="login__label">Confirm Password</label>
              <input
                type="password"
                id="conf_password"
                class="login__input"
                autocomplete="off"
                placeholder="Confirm password"
                v-model="confirm_password"
              />
            </div>
          <div class="login__forget">
            <p class="txt--xs text-danger text-left">{{errorResponse}}</p>
            <p class="txt--xs text-success text-left">{{successResponse}}</p>
          </div>
        </div>
        <div class="login__submit mt-4">
          <button
            type="button"
            @click="changePassword"
            class="button button--md button--primary login__button"
            :class="{'disabled':password == '' || confirm_password==''}"
          >Change Password</button>
          <p class="txt--xs">
            Don’t have an account yet?
            <a href="mailto:hello@piedparker.com?subject=Hello!" class="txt--primary txt--semi-bold">Get in touch</a>
          </p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "ForgotPassword",
  data() {
    return {
        email: "",
        password: "",
        confirm_password:"",
        errorResponse: "",
        successResponse : '',
        email_show : false,
        password_show : false,
        user_email : '',
    };
  },
  created()
  {
    this.user_email = this.$route.query.token;
    this.verifyCache();
  },
  methods: {
    sendEmail() {
        this.successResponse="";
        this.errorResponse="";
        if (this.email == "") {
            this.errorResponse = "Please provide an email ";
        }
        else
        {
            this.axios.post(window.hostname+'/api/admin/forgot-password',{
                mode : 'sendMail',
                email : this.email,
                type : 'commercial',
                url : window.location.origin,
                device_type : 1 ,
            })
            .then(res=>{
                console.log(res);
                if(res.data.status)
                {
                    this.email = '';
                    this.successResponse = res.data.message;
                }
                else
                {
                    this.errorResponse = res.data.message;
                }
            })
            .catch(err=>{
                console.log(err);
                this.errorResponse = err.response.data.message;
            });
        }
    },
    verifyCache(){
        // console.log(this.user_email);
        this.axios
            .post(window.hostname+'/api/admin/verify-cache',{
                device_type : 1,
                email : this.user_email
            })
            .then(res=>{
                console.log(res.data.message);
                // console.log('cache verified');
                this.password_show = true ;
                this.email_show = false ;
            })
            .catch(error=>{
                this.password_show = false ;
                this.email_show = true ;
                console.log(error.response.data.message);
                this.$router.push({path : '/forgot-password'});
            });
    },
    changePassword(){
        this.errorResponse='';
        this.successResponse = '';
        if(!this.password){
            this.errorResponse = 'Password is required';
        }
        else if(!this.confirm_password){
            this.errorResponse = 'Confirm Password is required';
        }else{
            this.axios
                .post(window.hostname+'/api/admin/forgot-password',{
                    mode  : 'changePassword',
                    //email : atob(this.user_email),
                    token : this.user_email,
                    password : this.password,
                    confirmPassword : this.confirm_password,
                })
                .then(res => {
                    if(res.data.status)
                    {
                        this.successResponse= res.data.message;
                        setTimeout(()=>{
                            this.$router.push({path:'/login'})
                        },1000);
                        
                    }
                    else
                    {
                        this.errorResponse = res.data.message;
                    }
                })
                .catch(error => {
                    this.errorResponse = error.response.data.message;
                });
        }
    }
  }
};
</script>

<style></style>
